<template>
  <div class="row">
    <div class="col-md-12">
      <select-equipe-profissional
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :callbackOnChangeProfissional="onChangeProfissional"
      >
      </select-equipe-profissional>
    </div>
    <div class="col-md-12">
      <div class="info-table" style="justify-content: flex-end">
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="busca-ativa"
          >
          </download-files>
        </div>
      </div>
      <TabelaCadastrosVuetify
        ref="table"
        :cadastros="displayedCadastros"
        :data_secretaria_de_saude="ultimaAtualizacao"
        texto_esus_pec="Procedimentos registrados até"
        :data_esus_pec="ultimaAtualizacao"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      />
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import * as Functions from './functions.js'
import SelectEquipeProfissional from '@/components/utils/SelectEquipeProfissional.vue'
import TabelaCadastrosVuetify from './TabelaCadastrosVuetify.vue'
import Subtitle from './Subtitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'BuscaAtivaPorEquipeAcs',
  components: {
    SelectEquipeProfissional,
    TabelaCadastrosVuetify,
    Subtitle,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipe: '',
      profissionais: [],
      profissional: '',
      cadastros: [],
      page: 1,
      perPage: 12,
      pages: [],
      nome: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nomeEquipe: '',
      nomeProfissional: '',
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == null) {
        this.cadastros = []
        return
      }
      this.equipe = event
      this.nomeEquipe = event.no_equipe
      try {
        this.loading = true
        let response = await this.$api.get(
          '/app/busca-ativa/equipe/' + this.cod_ibge + '/' + this.equipe.nu_ine
        )
        if (response) {
          this.cadastros = response.data
          this.total_de_registros_da_tabela = response.data.length
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == null) {
        this.cadastros = []
        return
      }
      this.page = 1
      this.profissional = event.nu_cpf
      this.buscarDados()
    },

    // busca os dados de acordo com os valores do select
    async buscarDados() {
      try {
        this.loading = true
        let profissional = await this.$api.get(
          '/app/profissional/' + this.profissional + '/' + this.cod_ibge
        )
        if (profissional) {
          this.nomeProfissional = profissional.data.no_profissional
          let response = await this.$api.get(
            '/app/busca-ativa/acs/' +
              profissional.data.co_ibge +
              '/' +
              profissional.data.nu_cpf
          )
          if (response) {
            //Esvazia os valores
            this.cadastros = []
            this.cadastros = response.data
            this.total_de_registros_da_tabela = response.data.length
            this.loading = false
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.profissional,
        this.nomeProfissional
      )
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
